import React, { useState } from "react";
import CustomSelect from "../../Common/CustomSelect";
// import CustomInput from '../../Common/CustomInput';

const countryOptions = [{ value: "+91", label: "IND (+91)" }];

const PhoneNumberInput = ({ formData, onChange,setFormData }) => {
 
  const handleCountryChange = (event) => {
    
    setFormData((pre)=>({...pre,dialCode:event.target.value}));
  };

  const handlePhoneNumberChange = (event) => {
    onChange(event.target.value );
  };

  return (
    <div className="mt-1 flex items-center rounded-md shadow-sm focus-within:ring-1 focus-within:ring-brand-500 focus-within:border-[#64c6b0] border border-gray-200 bg-gray-50">
      <CustomSelect
        value={formData.dialCode}
        onChange={handleCountryChange}
        options={countryOptions}
        
      />
      <input
        type="text"
        className="flex-1 block  w-full min-w-0 px-4 py-2 bg-gray-50 rounded-r-md focus:outline-none focus:ring-0 focus:border-0"
        placeholder="Enter your phone number"
        value={formData.phoneNumber}
        onChange={handlePhoneNumberChange}
      />
    </div>
  );
};

export default PhoneNumberInput;
